import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ticket } from '../models/ticket';
import { ResourcefulService } from './resourcefulService';

@Injectable({
    providedIn: 'root'
})
export class TicketService extends ResourcefulService<Ticket> {
    constructor(private httpClient: HttpClient) {
        super(httpClient, Ticket);
    }

    uploadAllegato(ticketId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this._httpClient
            .post<any>(`${this.baseUrl}/tickets/${ticketId}/allegati`, formData);
    }

    downloadAllegato(ticketId: number, allegatoId: number) {
        return this._httpClient.get(`${this.baseUrl}/tickets/${ticketId}/allegati/${allegatoId}/download`, {
            responseType: 'blob',
            observe: 'response'
        }) as unknown as Observable<HttpResponse<Blob>>;
    }
}
